import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'toToman',
 standalone: true,
})
export class RialToTomanPipe extends DecimalPipe implements PipeTransform {
 override transform(value: any, args?: any): any {
     //const rialValue = +value !== 0 ? (+value / 10).toFixed() : 0;
     const rialValue = +value !== 0 ? Math.ceil(+value / 10).toFixed() : 0;
  return  rialValue.toString(); // `${super.transform(Math.trunc(rialValue).toString())}`; return 
 }
}
